
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const MovingPage = lazy(() => import('../pages/moving/page'));
const FurniturePage = lazy(() => import('../pages/furniture/page'));
const DisposalPage = lazy(() => import('../pages/disposal/page'));
const CargoPage = lazy(() => import('../pages/cargo/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/moving',
    element: <MovingPage />,
  },
  {
    path: '/furniture',
    element: <FurniturePage />,
  },
  {
    path: '/disposal',
    element: <DisposalPage />,
  },
  {
    path: '/cargo',
    element: <CargoPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
